angular.module('filters').filter('waiverStatus', ["$filter", function($filter) {
  return function(waiver) {
    switch (false) {
      case !waiver.prefill_link_expired:
        return 'Link Expired';
      case waiver.status !== 'prefilled':
        return 'Not Signed';
      case waiver.review_status !== 'Pending Review':
        return 'Pending Review';
      default:
        return 'Signed';
    }
  };
}]);
